import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { AppEnum } from 'src/app/appenum';
import { AppService } from 'src/app/services/app.service';
import { EncryptionService } from 'src/app/services/encryption.service';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
  selector: 'app-permission-message',
  templateUrl: './permission-message.component.html',
  styleUrls: ['./permission-message.component.scss'],
  standalone: false
})
export class PermissionMessageComponent implements OnInit {
  permissionDenied$: Observable<boolean>;
  @ViewChild('messageDiv') messageDiv!: ElementRef;
  mode: any;
  constructor(
    public permissionService: PermissionService,
    public _appservice: AppService,
    public encryptionService: EncryptionService,
    private _appenum: AppEnum
  ) { }

  ngOnInit() {
    this.permissionDenied$ = this.permissionService.permissionDenied$;
  }

  shakeMessage() {
    if (this.messageDiv?.nativeElement) {
      this.messageDiv.nativeElement.classList.add('shake');
      setTimeout(() => {
        this.messageDiv.nativeElement.classList.remove('shake');
      }, 500);
    } else {
      console.error("messageDiv is undefined!");
    }
    if (navigator.vibrate) {
      navigator.vibrate([500, 300, 500]); // Vibrate for 500ms
    } else {
      console.log('Vibration API is not supported on this device.');
    }
  }


  checkGeolocationPermissionByService() {
    try {
      const raw = this.encryptionService.decrypt(
        this.encryptionService.localstorageDecrypt(
          this._appenum.EntityOfLocalStorageKeys.showLocationPermissionPage
        )
      );

      this.mode =                                    // ← store it
        raw === true || raw === 'true' ? 'required'
          : raw === 'optional' ? 'optional'
            : 'disabled';
      this.permissionService.checkGeolocationPermission(this.mode, true)
    }
    catch (err) {
      console.log("Permission Message ERR", err)
    }
  }
  async checkGeolocationPermission() {
    if (!navigator.permissions) {
      // alert("Permissions API not supported in this browser.");
      return;
    }

    try {
      const permissionStatus = await navigator.permissions.query({ name: "geolocation" });

      // alert("Geolocation permission status:" + permissionStatus.state);

      if (permissionStatus.state === "granted") {
        this.getUserLocation();
      } else if (permissionStatus.state === "prompt") {
        this._appservice.openModel(4);
        this.requestUserLocation();
      } else {
        this._appservice.openModel(4);
        // alert("Location permission is required. Please enable it in browser settings.");
      }

      // Listen for permission changes
      permissionStatus.onchange = () => {
        // alert("Permission changed:" + permissionStatus.state);
      };
    } catch (error) {
      console.error("Error checking geolocation permission:", error);
    }
  }

  async getUserLocation() {
    if (!navigator.geolocation) {
      // alert("Geolocation is not supported by this browser.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        this.permissionService.updatePermissionStatus(false);
      }, (error) => {
        if (error.code === error.PERMISSION_DENIED) {
          this.permissionService.updatePermissionStatus(false);
        } else if (error.code === error.POSITION_UNAVAILABLE) {
          this.permissionService.updatePermissionStatus(false);
        } else if (error.code === error.TIMEOUT) {
          this._appservice.openModel(3);
          this.permissionService.updatePermissionStatus(false);
        } else {
          this.permissionService.updatePermissionStatus(false);
        }
      },
      { timeout: 5000 } // Set timeout to avoid infinite waiting
    );
  }

  requestUserLocation() {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        this.permissionService.updatePermissionStatus(false);
        // alert("User granted permission. Latitude:" + position.coords.latitude);
      },
      (error) => {
        // alert("Error getting location:" + error.message);
      }
    );
  }
}
